import axios from "axios";
import { ICountry } from "../models/Country";

class CountriesServiceClass {
  async getAllCountries() {
    return await axios.get<ICountry[]>(`https://restcountries.com/v3.1/all?fields=name,idd,cca2`);
  }
}

export const CountriesService = new CountriesServiceClass();
